import { render, staticRenderFns } from "./CardWithTitle.vue?vue&type=template&id=2a369c62&scoped=true&"
import script from "./CardWithTitle.vue?vue&type=script&lang=js&"
export * from "./CardWithTitle.vue?vue&type=script&lang=js&"
import style0 from "./CardWithTitle.vue?vue&type=style&index=0&id=2a369c62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a369c62",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/home/runner/_work/studio/studio/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
installComponents(component, {VBtn,VIcon,VRow})
